import api from './request'

const findOrders = (query, page, size, warehouse, platform, userType) => {
    query.page = page
    query.size = size
    if (platform === 0) {
        platform = platform + ''
    }
    return api.postPromise('order/findOrders', { warehouse, platform, userType }, query, null, true)
}

export default {
    findOrders
}


// WEBPACK FOOTER //
// ./src/request/orderApi.js